import pako from "pako";

export const decompressTickerData = (compressedData) => {
    try {
        const binaryString = atob(compressedData);
        const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
        const decompressed = pako.ungzip(byteArray, { to: "string" });
        return JSON.parse(decompressed);
    } catch (error) {
        throw new Error(`Failed to decompress ticker data: ${error.message}`);
    }
};

export const fetchTickerData = async (apiFetch, dispatch, actionTypes) => {
    dispatch({ type: actionTypes.START });
    try {
        const today = new Date().toISOString().split('T')[0];
        const response = await apiFetch();
        
        if (response.status === 200) {
            const decodedData = decompressTickerData(response.result);
            const payload = {  
                details: decodedData, 
                fetchedDate: today
            };
            
            dispatch({ 
                type: actionTypes.SUCCESS, 
                payload
            });
            
            return decodedData;
        } else {
            const { handleApiError } = await import('../actions/notificationActions');
            handleApiError(response, dispatch);
            throw new Error(`API Error: Status ${response.status}`);
        }
    } catch (error) {
        const errorMessage = error.message || error.toString();
        
        dispatch({ 
            type: actionTypes.FAILURE, 
            payload: { error: errorMessage } 
        });
        
        throw error;
    }
};